// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__eAlE+","done":"MealItem_done__s4Ttl","description":"MealItem_description__z6SoW","price":"MealItem_price__T+hxt"};